/* Google Ads campaign ARCHITECTURE (config, not live advertising).
   Nothing here activates paid ads. Status is PLANNED until real Google Ads
   credentials + deployment exist. UTM structure is generated from this file.
   Conversion = START YOUR BUILD completed (lead_created). */

export const CAMPAIGN_STATUSES = ["PLANNED", "DRAFT", "ACTIVE", "PAUSED"];
export const PRIMARY_CONVERSION = "lead_created";
export const MICRO_CONVERSION = "start_build_click";

export const CAMPAIGNS = [
  {
    id: "ai-transformation-consulting",
    name: "AI Transformation Consulting",
    status: "PLANNED",
    channel: "google_search",
    objective: "High-intent leads for AI transformation engagements",
    landingSlug: "ai-transformation",
    intent: "commercial",
    adGroups: [
      { name: "AI Transformation", keywords: ["ai transformation", "ai transformation consulting", "ai transformation company"] },
      { name: "AI Consulting", keywords: ["ai consulting", "ai consulting services", "ai strategy consultant"] },
    ],
    headlines: ["AI Transformation, Shipped", "From AI Strategy to Production", "AI That Moves Real Numbers", "Start Your AI Build"],
    descriptions: [
      "We find where AI creates real leverage, then build and ship it. Start your build today.",
      "No endless pilots. Production AI with evaluation and human oversight. Get started.",
    ],
    cta: "Start Your Build",
  },
  {
    id: "custom-software-development",
    name: "Custom Software Development",
    status: "PLANNED",
    channel: "google_search",
    objective: "High-intent leads for custom software builds",
    landingSlug: "custom-software-development",
    intent: "commercial",
    adGroups: [
      { name: "Custom Software", keywords: ["custom software development", "custom software company", "bespoke software development"] },
      { name: "Software Development", keywords: ["software development company", "software development services"] },
    ],
    headlines: ["Custom Software, Built Right", "Software That Fits Your Business", "You Own the Code", "Start Your Build"],
    descriptions: [
      "Custom software designed around how you actually work. Clean architecture, real ownership.",
      "Stop bending your business around generic tools. Build exactly what you need.",
    ],
    cta: "Start Your Build",
  },
  {
    id: "mobile-app-development",
    name: "Mobile App Development",
    status: "PLANNED",
    channel: "google_search",
    objective: "High-intent leads for iOS/Android apps",
    landingSlug: "mobile-app-development",
    intent: "commercial",
    adGroups: [
      { name: "Mobile App Dev", keywords: ["mobile app development", "mobile app developer", "ios app development", "android app development"] },
    ],
    headlines: ["Mobile Apps, Done Well", "iOS & Android, One Team", "From Idea to App Store", "Start Your Build"],
    descriptions: [
      "Native-quality mobile apps designed and engineered end to end. Start your build today.",
      "Performance, polish and a launch plan. Build a mobile app users keep.",
    ],
    cta: "Start Your Build",
  },
  {
    id: "app-development",
    name: "Build an App",
    status: "PLANNED",
    channel: "google_search",
    objective: "Capture broad 'build an app' intent",
    landingSlug: "app-development",
    intent: "commercial",
    adGroups: [
      { name: "Build an App", keywords: ["app development", "build an app", "app development company", "how to build an app"] },
    ],
    headlines: ["Have an App Idea?", "Build Your App With Experts", "Idea to Launch", "Start Your Build"],
    descriptions: [
      "Turn your idea into a real, shipped app. Guided scoping, honest pricing, real ownership.",
      "We scope it, design it, build it, launch it. Start your build in minutes.",
    ],
    cta: "Start Your Build",
  },
  {
    id: "pwa-development",
    name: "PWA Development",
    status: "PLANNED",
    channel: "google_search",
    objective: "Capture PWA / installable web app intent",
    landingSlug: "pwa-development",
    intent: "commercial",
    adGroups: [
      { name: "PWA", keywords: ["pwa development", "progressive web app development", "installable web app"] },
    ],
    headlines: ["Progressive Web Apps", "One Build, Every Device", "App-Like, No App Store", "Start Your Build"],
    descriptions: [
      "Installable, offline-capable web apps across every device. Fast and cost-effective.",
      "Reach every device from one codebase. Build a PWA that feels native.",
    ],
    cta: "Start Your Build",
  },
  {
    id: "ai-automation",
    name: "AI Automation",
    status: "PLANNED",
    channel: "google_search",
    objective: "High-intent leads for AI automation / agents",
    landingSlug: "ai-automation",
    intent: "commercial",
    adGroups: [
      { name: "AI Automation", keywords: ["ai automation", "business automation", "ai workflow automation"] },
      { name: "AI Agents", keywords: ["ai agents", "custom ai agents", "ai agent development"] },
    ],
    headlines: ["Automate the Busywork", "AI Automation, In Production", "Agents That Do the Work", "Start Your Build"],
    descriptions: [
      "Put AI to work on your highest-volume tasks, with guardrails and human oversight.",
      "From automated workflows to AI agents — built, measured and shipped. Get started.",
    ],
    cta: "Start Your Build",
  },
  {
    id: "mvp-development",
    name: "MVP Development",
    status: "PLANNED",
    channel: "google_search",
    objective: "Capture startup/MVP build intent",
    landingSlug: "mvp-development",
    intent: "commercial",
    adGroups: [
      { name: "MVP", keywords: ["mvp development", "mvp development company", "build an mvp", "startup mvp"] },
    ],
    headlines: ["Ship Your MVP", "Validate Fast, Build Right", "MVP Without the Throwaway", "Start Your Build"],
    descriptions: [
      "A focused MVP built on a foundation the winning version can grow from. Start now.",
      "Prove your idea with real users, fast — without cutting the wrong corners.",
    ],
    cta: "Start Your Build",
  },
  {
    id: "saas-development",
    name: "SaaS Development",
    status: "PLANNED",
    channel: "google_search",
    objective: "Capture SaaS platform build intent",
    landingSlug: "saas-development",
    intent: "commercial",
    adGroups: [
      { name: "SaaS", keywords: ["saas development", "saas development company", "build a saas product"] },
    ],
    headlines: ["Build Your SaaS", "SaaS, Engineered to Scale", "Multi-Tenant, Done Right", "Start Your Build"],
    descriptions: [
      "SaaS platforms built for multi-tenancy, billing and scale from day one. Start your build.",
      "From subscriptions to dashboards — a SaaS product ready for real customers.",
    ],
    cta: "Start Your Build",
  },
];

// Funnel-stage retargeting audiences (definitions only; inactive until consent + pixel config).
export const RETARGETING_AUDIENCES = [
  { id: "all_visitors", name: "All visitors", definition: "Anyone who viewed AIROTECH", stage: "awareness" },
  { id: "service_viewers", name: "Service viewers", definition: "Viewed a service/landing page (service_view)", stage: "consideration" },
  { id: "questionnaire_starters", name: "Questionnaire starters", definition: "Started /start (questionnaire_started)", stage: "intent" },
  { id: "questionnaire_abandoners", name: "Questionnaire abandoners", definition: "Started but did not complete", stage: "intent", priority: true },
  { id: "leads", name: "Qualified leads", definition: "Completed the questionnaire (lead_created)", stage: "decision" },
];
